// Per-item prep floor: a guaranteed MINIMUM prep increase for these items,
// regardless of the store's Sales Forecast Adjustment. Single source of truth
// so adding/removing a floor item is a one-line change.
//
// why: lives here rather than inside the calculator because the admin setting
// page states these values to whoever sets a percentage, and two copies would
// drift the moment one is edited.
export const PREP_ITEM_FLOORS: {
  id: string
  label: string
  floorPercent: number
}[] = [
  { id: 'brownies', label: 'Brownies', floorPercent: 15 },
  // why: keyed on prep_item_categories.id — 'blue-cheese', not
  // 'blue-cheese-dip', which is what made this floor silently dead since April.
  { id: 'blue-cheese', label: 'Blue Cheese', floorPercent: 15 },
  { id: 'carrots', label: 'Carrots', floorPercent: 10 },
]

export const ITEM_FLOORS: Record<string, number> = PREP_ITEM_FLOORS.reduce(
  (acc, item) => ({ ...acc, [item.id]: item.floorPercent }),
  {} as Record<string, number>,
)

// why: returns the floor (0 for non-floor items). The calculator applies it as
// Math.max(floor, adjustment) on the prep amount, so the floor is a minimum the
// store can't go below — it never stacks multiplicatively on the adjustment.
export const getItemPrepFloor = (prepItemIdCode: string): number =>
  ITEM_FLOORS[prepItemIdCode] ?? 0

// why: a percentage below a floor leaves those items at the floor, which reads
// as the setting having been ignored unless it is said up front.
export const getFloorItemsAbove = (percent: number) =>
  PREP_ITEM_FLOORS.filter((item) => item.floorPercent > percent)
